import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { REQUEST_USER_INFO, REQUEST_USER_PERM } from 'src/constants'
import './style.less'

function Container(props: any) {
  const { children } = props
  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()
  const noPermPath = ['/pure/register', '/pure/forgetPassword', '/pure/agreement', '/pure/mkt-agreement', '/pure/privacy', '/pure/invalid']
  // 注册和协议页面无需获取用户
  if (noPermPath.indexOf(location.pathname) === -1) {
    useEffect(() => {
      dispatch({
        type: REQUEST_USER_INFO,
        callback: (res: any) => {
          if (res.customer_id === 0) {
            history.push('/pure/add-auth')
          }
        }
      })
      // 获取用户权限
      dispatch({
        type: REQUEST_USER_PERM
      })
    }, [])
  }

  return (
    <div className="bm-container">
      {children}
    </div>
  );
}

export default Container 


// WEBPACK FOOTER //
// ./src/containers/Container.tsx